export default __webpack_public_path__ + "static/media/billings-not-selected.b37ba685.svg";